import React, { useEffect, useState } from 'react'
import CreateEquipments from './CreateEquipments';
import ImportEquipments from './ImportEquipments';

import { useFormik } from 'formik';

import * as yup from 'yup';
import UseGetDataSearchByProUser from '../../../../Components/Hooks/useFetchDataByPROUser';
import { useToast } from '../../../../Components/Others/ToastServices';
import { useLocation } from 'react-router-dom';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import EquipmentsMobileIndex from '../../../Mobile/ClientManage/Equiments/EquipmentsMobileIndex';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { CancelButton, ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import CloseIcon from '../../../../Components/Icons/Close';
import { NuDate } from '../../../../Components/Utils/Input';
import MultiEquipments from './MultiEquipments';
import SearchBar from '../../../../Components/Utils/SearchBar';
import axiosInstance from '../../../../Services/axiosCommon';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';



const EquipmentsIndex = () => {
 
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
      });
    
      useEffect(() => {
        const handleResize = () => {
          setScreenSize({
            width: window.innerWidth,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);
    const toast = useToast();
    const location = useLocation();
     const currentPage= location.state?.currentPage
    const searchQuery= location.state?.searchQuery
    const [page, setPage] = useState(currentPage||1)
    const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
    const [filter, setFilter] = useState(false);
    const [showFilterDialog, setShowFilterDialog] = useState(false);
    const {value:brand} = useFetchMDIndex
    (`/dropdown/dropdown-details/`,'brand_equipments',showFilterDialog)
    const {value:unit} = useFetchMDIndex
    (`/dropdown/dropdown-details/`,'unit_equipments',showFilterDialog)
   
     const [createModalOpen, setCreateModalOpen] = useState(false); // State to handle modal open/close
    const [projectList, setProjectList] = useState([]);
    // const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
    const [open, setOpen] = useState(false);
  
    const [filterProps, setFilterProps] = useState({
     
      brand:"",
      
    });
    const [params, setParams] = useState({
      page: page,
      per_page: pageCount,
      search:searchQuery||"",
     
      brand:"",
      
    });
    const clearFilter = ()=> {
      setParams({...params,
      brand:"",
      
    })
   
    formik.values.brand=""
   
  
  
        setFilter(false)
    }
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: filterProps,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        // email: yup.string().required('Email is required!'),
      }),
      onSubmit: async (value, { resetForm }) => {
        console.log("ffff",value);
        setParams({...params,brand:value.brand})
        closeFilterDialog();
        setFilter(true)
        setFilterProps({
         
          brand:"",
        
        });
      }
    })
    
  
    const { data, totalCount, getData,dataLoading } = UseGetDataSearch( `/equipments/`,params);
    const defaultHeader = [
      {
        title: "ID",
        width: "5%",
        
        field: "id",
        textAlign: "center",
        rowAlign: "center",
      },
      {
        title: "Equipments",
        width: "40%",
         
        field: "name",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Unit",
        width: "10%",
         
        field: "unit",
        textAlign: "center",
        rowAlign: "center",
      },
      {
        title: "Brand",
        width: "10%",
         
        field: "brand",
        textAlign: "center",
        rowAlign: "center",
      },
      {
        title: "Model No.",
        
        width: "15%",
        field: "model",
        textAlign: "center",
        rowAlign: "center",
      },
     
      {
        title: "Action",
        width: "5%",
        field: "action",
        textAlign: "center",
        rowAlign: "center",
       
          contents:{
            // fetcher:getData,
            id:"id",
            removeValue:"name",
            url:`/equipments/`,
            moduleName:"Equipments",
            from:`/settings/equiments`,
            editLink:`/settings/equiments/edit/`,
            viewLink:`/settings/equiments/view/`
          }    
        },
      
    ];
    const availableHeaders = [
      
      
    ];
    const [showExport, setShowExport] = useState(false);
    const [exportValue, setExportValue] = useState({
      Client:"",
      Project:"",
      salesPerson:"",
      Location:"",
      Inspector:"",
      InspectionDate:"",
      Status:"",
    });
    const ExportFormik = useFormik({
      enableReinitialize: true,
      initialValues: exportValue,
      validateOnChange: false,
      validateOnBlur: false,
      onSubmit: async (value, { resetForm }) => {
        try {
          const response = await axiosInstance.get(
            `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
            {
              responseType: "blob",
            }
          );
  
          const pdfBlob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
  
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(pdfBlob);
          link.download = `CQ Report ${NuDate({
            value: new Date(),
            format: "DD-MMM-YYYY",
          })}.xlsx`;
  
          document.body.appendChild(link);
          link.click();
  
          link.parentNode.removeChild(link);
        } catch (error) {
          console.error("Error downloading the PDF:", error);
        }
      },
    });
    const closeFilterDialogebox = () => {
      setShowExport(false);
    };
  
    useEffect(()=>{
      setParams({...params,page:page,per_page:pageCount})
     },[page,pageCount])
  
      const closeFilterDialog = () => {
        setShowFilterDialog(false);
      };
        const [showImportModal, setShowImportModal] = useState(false);
  
      const handleImportClick = () => {
        setShowImportModal(true);
      };
    
      const closeModal = () => {
        setShowImportModal(false);
      };
  
  
      const [showEdit, setShowEdit] = useState(false)
      const [showDelete, setShowDelete] = useState(false)
      const [listofNumbers, setListofNumbers] = useState([])
      const [fullList, setFullList] = useState([])
    
      const selectOneFunction = (value) =>{ 
        let NewId;
        if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
          NewId = listofNumbers.filter(Temp=> Temp !== value);
          setListofNumbers(NewId)
        }else{
          setListofNumbers([...listofNumbers,value])
        }
      }
    
     const selectMultipleFunction = (e) => {
         if (e.target.checked) {
           console.log("if List", fullList);
           setListofNumbers(fullList);
         } else {
           console.log("else List", fullList);
           setListofNumbers([]);
         }
       };
     
       useEffect(() => {
         let tempArr = [];
         data &&
           data.forEach((i) => {
             console.log("I", i);
             tempArr.push(i?.id);
           });
         setFullList(tempArr);
       }, [data]);
     
      

     
      
    
  
      
    return (
       <>
      
              <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex justify-end items-center'>
       
        <div className=' flex gap-2'>
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            />
          
          <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <ClearFilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
            <ImportButton handleClick={handleImportClick} />
            <ExportButton handleClick={() => setShowExport(true)}/>
             <CreateButton handleClick={()=>setCreateModalOpen(true)} label='Equipment' />

        </div>
      </div>
          {
    screenSize.width <= "786" ?(<>
    <div className=' w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
    <EquipmentsMobileIndex
    data={data}
    total={totalCount}
    pageIndex={page}
    setPageIndex={setPage}
    dataCount={pageCount}
    setDataCount={setPageCount}
             getData={getData}
  
    />
    </div>
    </>):(<>
      <div className='w-full h-full '>
  
        <CustomDataTable 
        fetcher={getData}
          data={data} 
          availableHeaders={availableHeaders} 
          defaultHeader={defaultHeader}
          bodyHeight='max-h-[calc(100vh-260px)] '
          height='h-[calc(100vh-160px)]'
          total={totalCount}
          pageIndex={page}
          setPageIndex={setPage}
          dataCount={pageCount}
          setDataCount={setPageCount}
          // title='Equipments List' 
          storageName="EquipmentsTable"
          selectOneFunction={selectOneFunction}
          setShowDelete={setShowDelete}
          showDelete={showDelete}
          setShowEdit={setShowEdit}
          showEdit={showEdit}
          listofNumbers={listofNumbers}
          hasMultiEdit={true}
          selectMultipleFunction={selectMultipleFunction}
          fullList={fullList}
          getById="id"
          showFieldFalse={false}
          // editAccess="items_edit"      
          // deteleAccess="items_delete"
          dataLoading={dataLoading}   
          searchQuery={params?.search!=""?params?.search:""}
          />
      </div>
      </>)
    }
             {/* </ClientManagementLayout> */}
             {showEdit && (
        <MultiEquipments
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportEquipments
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
           <CreateEquipments
            open={createModalOpen}
            onCancel={() => {
              setCreateModalOpen(false);
            }}
            projectList={projectList || []}
            getData={getData}
            // firstProject={firstProject}
          />
            {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
              <FormikSelectTwo
                type="text"
                label="Unit"
                placeholder="Choose unit"
                Options={unit}
                formik={formik}
                name="unit"
                width="w-full"
                 />
               <FormikSelectTwo
                type="text"
                label="Brand"
                placeholder="Choose Brand"
                Options={brand}
                formik={formik}
                name="brand"
                width="w-full"
                 />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
           {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <NuDate
                      label="From "
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="fromDate"
                      width="w-1/2 "
                    />
                    <NuDate
                      label="To "
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="toDate"
                      width="w-1/2"
                    />

                    <FormikSelectTwo
                      type="text"
                      label="Sales Person"
                      placeholder="Choose"
                      Options={[]}
                      formik={ExportFormik}
                      name="salesPerson"
                      width="w-1/2"
                    />

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
         
      </div>
      </>
    )
  }
  

export default EquipmentsIndex